// Enum with values
export enum EmergencyQuestionValue {
	Contact = 'Contact',
	Trapped = 'Trapped',
	Injuries = 'Injuries',
	Fire = 'Fire',
	Arcing = 'Arcing',
	TrafficSignalOut = 'Traffic Signal Out',
	TrafficSignalBlinking = 'Traffic Signal Blinking',
	DownedWire = 'Downed Wire',
	Hazard = 'Hazard',
	BrokenLeaningPole = 'Broken or Leaning Pole',
	TrafficSignal = 'Traffic Signal',
}
